import { ReactNode } from 'react';
import type { Habillage as HabillageData } from '@/types/app';
import './Habillage.scss';

interface HabillageProps {
  habillage?: HabillageData | null;
  children: ReactNode;
}

export function Habillage({ habillage, children }: HabillageProps) {
  if (!habillage) {
    return <>{children}</>;
  }

  const backgroundStyle = {
    backgroundImage: `url('${habillage.background}')`,
    backgroundSize: `${habillage.size}px`,
    ...(habillage.color ? { backgroundColor: habillage.color } : {}),
  };

  return (
    <div
      className="container-page habillage-pub"
      style={{
        ['--habillage-content-max-width' as string]: `${habillage.contentSize}px`,
      }}
    >
      {habillage.link ? (
        <a
          href={habillage.link}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="bg-pub-habillage"
          style={backgroundStyle}
          aria-label="Publicité habillage"
        />
      ) : (
        <span className="bg-pub-habillage" style={backgroundStyle} aria-hidden="true" />
      )}
      <div className="habillage-pub__inner" style={{ paddingTop: `${habillage.margin}px` }}>
        {children}
      </div>
    </div>
  );
}

export default Habillage;
